import ApiService from "../../ApiService";

const DefaultService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/practice/loadscreenview", {id}, successCallback, failureCallback);
    },
    updateUnitResult: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/practice/updateunitresult", vo, successCallback, failureCallback);
    },
    restart: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/practice/restart", vo, successCallback, failureCallback);
    },
    complete: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/practice/complete", vo, successCallback, failureCallback);
    },
    nextUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/practice/nextunit", vo, successCallback, failureCallback);
    },
};

export default DefaultService;
